
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
:host {

    position: relative;

    margin-left: auto;

    margin-right: auto;

    display: block;

    max-width: max-content;

    padding: 1rem;
}

  @media (min-width: 1024px) {

    :host ul {

        display: flex;
    }
}

  :host ul li {

    display: flex;
}

  :host ul li {

    height: 240px;
}

  :host ul li {

    align-items: center;
}

  @media (min-width: 1024px) {

    :host ul li {

        height: 380px;
    }
}

  @media (min-width: 1024px) {

    :host ul li {

        width: 400px;
    }
}

  @media (min-width: 1024px) {

    :host ul li {

        flex-wrap: wrap;
    }
}

  @media (min-width: 1024px) {

    :host ul li {

        padding: 2rem;
    }
}

:host([bg-color='dark']) {

    border-radius: 0.75rem;

    background-color: var(--primary-blue);

    color: var(--neutral-white);
}

:host([bg-color='dark']) * {

    color: var(--neutral-white);
}

:host([bg-color='light-blue']) {

    border-radius: 0.75rem;

    background-image: var(--light-blue-gradient);

    color: var(--primary-blue);
}

:host([bg-color='light-blue']) * {

    color: var(--primary-blue);
}

:host([bg-color='white']) {

    border-radius: 0.75rem;

    background-color: var(--neutral-white);

    color: var(--primary-blue);
}

:host([bg-color='white']) * {

    color: var(--primary-blue);
}

.statistic-card-icon {

    display: flex;

    width: 50%;

    justify-content: center;

    padding: 0.5rem;
}

.statistic-card-icon ghs-icon {

    width: 100%;
}

.statistic-card-content {

    width: 50%;

    padding: 0.75rem;
}

li[elements='1'] .heading, li[elements='2'] .heading, li[elements='3'] .heading {

    white-space: nowrap;
}

li[elements='1'] .heading, li[elements='2'] .heading, li[elements='3'] .heading {

    padding-bottom: 0.5rem;
}

li[elements='1'] .heading, li[elements='2'] .heading, li[elements='3'] .heading {

    font-family: var(--ff-display);
}

li[elements='1'] .heading, li[elements='2'] .heading, li[elements='3'] .heading {

    font-size: var(--fs-h1-small);

    line-height: var(--lh-h1-small);
}

li[elements='1'] .heading, li[elements='2'] .heading, li[elements='3'] .heading {

    font-weight: var(--fw-bold);
}

@media (min-width: 1280px) {

    li[elements='1'] .heading, li[elements='2'] .heading, li[elements='3'] .heading {

        font-size: var(--fs-h1);

        line-height: var(--lh-h1);
    }
}

li[elements='1'] .text, li[elements='2'] .text, li[elements='3'] .text {

    font-family: var(--ff-display);
}

li[elements='1'] .text, li[elements='2'] .text, li[elements='3'] .text {

    font-size: var(--fs-h5-small);

    line-height: var(--lh-h5-small);
}

li[elements='1'] .text, li[elements='2'] .text, li[elements='3'] .text {

    font-weight: var(--fw-bold);
}

li[elements='4'] .heading {

    white-space: nowrap;
}

li[elements='4'] .heading {

    padding-bottom: 0.5rem;
}

li[elements='4'] .heading {

    font-family: var(--ff-display);
}

li[elements='4'] .heading {

    font-size: var(--fs-h2-small);

    line-height: var(--lh-h2-small);
}

li[elements='4'] .heading {

    font-weight: var(--fw-bold);
}

@media (min-width: 768px) {

    li[elements='4'] .heading {

        font-size: var(--fs-h2-medium);

        line-height: var(--lh-h2-medium);
    }
}

@media (min-width: 1024px) {

    li[elements='4'] .heading {

        font-size: var(--fs-h2);

        line-height: var(--lh-h2);
    }
}

li[elements='4'] .text {

    font-family: var(--ff-display);
}

li[elements='4'] .text {

    font-size: var(--fs-base);

    line-height: var(--lh-base);
}

li[elements='4'] .text {

    font-weight: var(--fw-bold);
}
`;